import { Component, forwardRef, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';
import { ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';
import { default as ngLang } from '@angular/common/locales/zh';

@Component({
  selector: 'app-d-string',
  templateUrl: './d-string.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DStringComponent),
      multi: true
    }
  ]
})
export class DStringComponent extends DynamicComponentBase implements AfterViewInit {
  @ViewChild('input') input;
  static KEY = 'd-string';

  constructor() {
    super();
  }
  ngAfterViewInit(): void {}

  configChange(config: IDynamicComponentConfig) {}
}
